<template>
  <div class="theme-toggle" @click="$emit('toggle-theme')">
    <div class="toggle-track">
      <div class="toggle-indicator" :class="theme">
        <svg
          v-if="theme === 'light'"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
        <svg
          v-if="theme === 'dark'"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThemeToggle",
  props: {
    theme: String,
  },
};
</script>

<style scoped>
.theme-toggle {
  cursor: pointer;
}
.toggle-track {
  width: 50px;
  height: 26px;
  background-color: #e0e0e0;
  border-radius: 13px;
  position: relative;
  transition: background-color 0.3s ease;
}
.toggle-indicator {
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-indicator.dark {
  transform: translateX(24px);
}
.toggle-track:has(.dark) {
  background-color: #4d4d4d;
}
.toggle-indicator svg {
  color: #888;
}
</style>
